declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool, AutoGenList, AutoGenListH } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-listhpv',
    templateUrl: './autogenlisthpv.component.html',
    styleUrls: ['./autogenlisthpv.component.scss']
})

export class AutoGenListHPVComponent implements OnInit {
    @Input() public Data: AutoGenListH;
    @Input() public field: FieldData;
    ngOnInit(): void {
       
    }
}
